module.exports = __webpack_public_path__ + "static/media/WhipAround_android_2_preview.504ed867.jpg";